import { createApp } from 'vue'
import App from './App.vue'
import { ElImage, ElPopconfirm } from 'element-plus';
// 适配pc、mobile样式
// import { _isMobile } from '@/utils/utils.js'
// 判断并适配pc、mobile样式
// if (_isMobile()) {
    require('./styles/mobile.css');
// } else {
//     require('./styles/pc.css');
// }
// require('./styles/mobile.css');
import router from './router'

const app = createApp(App)
app.use(ElImage) // 引入Image组件
app.use(ElPopconfirm) // 引入Popconfirm组件
app.use(router).mount('#app')


